// React
import PropTypes from "prop-types";

// Hooks
import "../../assets/styles/hero.css";

/**
 * Generic full-width hero banner with optional children.
 */
export default function Hero({
  bgImage,
  title,
  className = "",
  children,
}) {
  return (
    <header
      className={`hero ${className}`.trim()}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <h1 className="heroTitle">{title}</h1>
      {children}
    </header>
  );
}

Hero.propTypes = {
  bgImage:   PropTypes.string.isRequired,
  title:     PropTypes.string.isRequired,
  className: PropTypes.string,
  children:  PropTypes.node,
};
